import { createTheme } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    xs: true;
    sm: true;
    md: true;
    lg: true;
    mlg: true;
    xl: true;
  }
}

const ThemeCustomization = (primaryColor: string, accentColor: string) => {
  let theme = createTheme();

  theme = createTheme({
    palette: {
      primary: {
        main: primaryColor,
      },
      secondary: {
        main: accentColor,
      },
      background: {
        default: theme.palette.background.paper,
      },
    },
    components: {
      MuiContainer: {
        styleOverrides: {
          root: {
            paddingTop: '20px',
            paddingBottom: '50px',

            '&.container-inner': {
              padding: '0',

              [theme.breakpoints.up('md')]: {
                margin: '0',
              },
            },

            '&.container-row': {
              padding: '0',

              [theme.breakpoints.up('md')]: {
                display: 'flex',
              },
            },
          },
        },
      },
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        mlg: 1440,
        xl: 1920,
      },
    },
  });

  return theme;
};

export default ThemeCustomization;
